import { RootStore } from '@vromo/dashboard/src/stores/RootStore';
import { useStore } from '@vromo/mobx-react/mobx-react';
import { LocalStorage } from '@vromo/models';
import FontAwesome from '@vromo/ui/components/FontAwesome';
import { observer } from 'mobx-react-lite';
import React, { Suspense, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { animated, useSpring } from 'react-spring';
import styles from './enterpriseDispatchBanner.style';

const TRANSITION_TIME = 800;

const EnterpriseDispatchBanner = observer(() => {
    const { t } = useTranslation();
    const rootStore = useStore<RootStore>('rootStore');
    const { jobStore, viewStore } = rootStore;

    const [isVisible, setIsVisible] = useState(
        LocalStorage.enterpriseDispatch && !LocalStorage.enterpriseDispatchInfoBannerIsDismissed
    );
    const [isTransitioningOut, setTransitioningOut] = useState<boolean>(false);

    useEffect(() => {
        if (!isVisible) {
            LocalStorage.enterpriseDispatchInfoBannerIsDismissed = true;
        } else delete LocalStorage.enterpriseDispatchInfoBannerIsDismissed;
    }, [isVisible]);

    useEffect(() => {
        if (viewStore.showingBetaBanner) {
            setIsVisible(true);
        }
    }, [viewStore.showingBetaBanner]);

    const props = useSpring({
        transform:
            !jobStore.loaded || isTransitioningOut || !isVisible
                ? 'translateY(-300px)'
                : 'translateY(0px)',
        animationDuration: TRANSITION_TIME
    });

    const closeDialog = () => {
        setTransitioningOut(true);
        setTimeout(() => {
            setIsVisible(false);
            setTransitioningOut(false);
            viewStore.showingBetaBanner = false;
        }, TRANSITION_TIME);
    };

    if (!LocalStorage.enterpriseDispatch || !jobStore.loaded || !isVisible) return null;

    return (
        <Suspense fallback={<div />}>
            <animated.div className={styles.container} style={props}>
                <img className={styles.betaTag} src={require('./beta_tag.png')} />
                <div className={styles.title}>{t('dispatch.betaTitle')}</div>
                <div>{t('dispatch.betaDescription')}</div>
                <FontAwesome
                    className={styles.closeIcon}
                    icon="times-circle"
                    onClick={closeDialog}
                />
            </animated.div>
        </Suspense>
    );
});

export default EnterpriseDispatchBanner;
